import { version } from 'element-ui'
import Vue from 'vue'

// 权限指令
let has = Vue.directive('has', {
    // 当绑定的元素插入到DOM时
    inserted(el, binding) {
        let btnRules = binding.value
        if (!Vue.prototype.$has(btnRules)) {
            if (!el.parentNode) {
                el.parentNode.removeChild(el);
            } else {
                Vue.nextTick(() => {
                    el.parentNode.removeChild(el)
                });
            }
        }
    }
})

Vue.prototype.$has = function (value) {
    let isShow = false;
    let userRules = localStorage.getItem('permission')
    if (userRules == undefined || userRules == null) {
        return false;
    }

    // let userRules = userRuleStr.split(",");
    let res = value.filter((x) => {
        return userRules.includes(x);
    })

    if (res.length > 0) {
        isShow = true;
    } else {
        isShow = false;
    }
    return isShow;
}

export { has }